import React, { useEffect } from 'react';
import {
  CreateNewMockupButton,
  CreateNewMockupButtonContainer,
  FilterContainer,
  SearchInputContainer
} from './styles';
import {
  IFabricationMockup,
  IFabricationMockupsState,
  IPavementOrder
} from '../../../../../store/ducks/fabrication-mockups/types';
import moment from 'moment';
import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto/Button';
import { Icon } from '@gerdau/hefesto/Icon';
import { SearchField } from '@gerdau/hefesto/SearchField';
import { useLocation } from 'react-router-dom';
import { getTaggingInformationScreen } from '../../../../../utils/Tagging';
import { sendTagging } from '../../../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';

interface IMockupsFilterProps {
  mockupsState: IFabricationMockupsState;
  filteredMockups: IFabricationMockup[];
  setFilteredMockups(filteredMockups: IFabricationMockup[]): void;
  searchInput: string;
  setSearchInput(value: string): void;
  onNewMockupClick(): void;
  onCleanFilters(): void;
}

const MockupsFilter: React.FC<IMockupsFilterProps> = ({
  mockupsState,
  setFilteredMockups,
  searchInput,
  setSearchInput,
  onNewMockupClick,
  onCleanFilters
}) => {
  const { pathname } = useLocation();
  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    pathname,
    true
  );

  const dispatch = useDispatch();

  const cleanFilters = () => {
    cleanFilterInputs();
    onCleanFilters();
    dispatch(
      sendTagging({
        event: 'click',
        screenName,
        itemDescription: `${itemDescription}_maquetes_limparFiltros`,
        filterInfo: `#flt:${searchInput}`
      })
    );
  };

  const cleanFilterInputs = () => {
    setSearchInput('');
  };

  useEffect(() => {
    if (mockupsState.loading) {
      cleanFilterInputs();
    }
  });

  const onFilter = (newSearchInputValue: string) => {
    const handleFilterBySearchInput = (
      searchInputValue: string,
      mockups: IFabricationMockup[]
    ) => {
      return mockups.filter((mockup) => {
        const getQuantities = (): {
          associatedProjects: number;
          orderQuantities: number;
          deliveredVolume: number;
        } => {
          const pavementProjectsIds: number[] = [];
          const orders: IPavementOrder[] = [];

          mockup.pavements.forEach((pav) => {
            pav.projects?.forEach((proj) => {
              if (!pavementProjectsIds.includes(proj.id)) {
                pavementProjectsIds.push(proj.id);
              }
            });

            pav.orders?.forEach((order) => {
              if (!orders.find((or) => order.id === or.id)) {
                orders.push(order);
              }
            });
          });

          const deliveredVolume = orders.reduce(
            (accVolume, currOrder) => accVolume + currOrder.totalWeight,
            0
          );

          return {
            associatedProjects: pavementProjectsIds.length,
            orderQuantities: orders.length,
            deliveredVolume
          };
        };
        const { orderQuantities, associatedProjects, deliveredVolume } =
          getQuantities();

        return (
          mockup.name.toUpperCase().includes(searchInputValue) ||
          mockup.pavements.length.toString() === searchInputValue ||
          moment(mockup.pavements[0].updatedAt)
            .format('DD/MM/YYYY')
            .startsWith(searchInputValue) ||
          orderQuantities.toString() === searchInputValue ||
          associatedProjects.toString() === searchInputValue ||
          deliveredVolume.toString() === searchInputValue
        );
      });
    };

    let newFilteredMockups = mockupsState.mockups || [];

    setSearchInput(newSearchInputValue);
    newFilteredMockups = handleFilterBySearchInput(
      newSearchInputValue.toUpperCase(),
      newFilteredMockups
    );

    setFilteredMockups(newFilteredMockups);
  };

  return (
    <>
      <FilterContainer>
        <Title level={3}>Filtros</Title>
        <SearchInputContainer>
          <SearchField
            inputValue={searchInput}
            placeholder="Pesquise uma maquete"
            disabled={false}
            onChange={(e) => onFilter(e.target.value)}
            label={'Pesquisar'}
            name={'search'}
            helperText={
              'É possível pesquisar por maquete, número do pedido, projeto associado, peso total e data da última atualização.'
            }
          />

          <Button
            variant="secondary"
            onClick={cleanFilters}
            disabled={false}
            name={'cleanFilters'}
          >
            Limpar filtros
          </Button>
        </SearchInputContainer>
      </FilterContainer>
      <CreateNewMockupButtonContainer>
        <CreateNewMockupButton>
          <Button
            variant="secondary"
            onClick={onNewMockupClick}
            disabled={false}
            name={'createNewMockup'}
            icon={<Icon option={'Plus'}></Icon>}
          >
            Criar nova maquete
          </Button>
        </CreateNewMockupButton>
      </CreateNewMockupButtonContainer>
    </>
  );
};

export default MockupsFilter;
